import React from 'react';
import Logs from 'components/Logs';

const VehicleLogs = ({ id }) => {
  return <Logs targetId={parseInt(id)} targetType="Vehicle" title="Vehicle Logs" />;
};

export default VehicleLogs;
